export default function isItemClassMeetingMessage(itemClass: string): RegExpMatchArray | null {
    return itemClass.match(/^ipm\.(appointment|schedule\.meeting(?!\.notification))/i);
}
